<template>
    <div>
			<b-table-simple responsive bordered  style="width: 100%;">
				<b-thead>
						<b-tr v-if="import_status != 'NEW'">
							<b-th rowspan="2">No.</b-th>
							<b-th class="text-center bg-warning" v-if="import_status == 'EXISTS'">Existing Data</b-th>
							<b-th class="text-center bg-info" colspan="6">New Import Data</b-th>
						</b-tr>
						<b-tr>
							<b-th v-if="import_status == 'NEW'">No.</b-th>
							<b-th v-if="import_status != 'NEW'">Customer Id</b-th>
							<b-th>Name</b-th>
							<b-th>Dob</b-th>
							<b-th>NRIC</b-th>
							<b-th>Email</b-th>
							<b-th>Contact No</b-th>
							<b-th>Gender</b-th>
						</b-tr>
				</b-thead>
				<b-tbody v-if="!_gHlp.isEmpty(tableData)">
						<b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
								<b-td>{{ index + 1 }}</b-td>
								<b-td v-if="import_status != 'NEW'">{{ item.customer_id }}</b-td>
								<b-td class="text-left">{{ item.name }}</b-td>
								<b-td class="text-left">{{ item.dob }}</b-td>
								<b-td class="text-left">{{ item.nric }}</b-td>
								<b-td class="text-left">{{ item.email }}</b-td>
								<b-td class="text-left">{{ item.contact_no }}</b-td>
								<b-td class="text-left">{{ item.gender }}</b-td>
						</b-tr>
				</b-tbody>
				<b-tbody v-else>
						<b-tr>
								<b-td colspan="8" v-if="import_status == 'EXISTS'"><i>No Record</i></b-td>
								<b-td colspan="7" v-if="import_status != 'EXISTS'"><i>No Record</i></b-td>
						</b-tr>
				</b-tbody>
			</b-table-simple>
    </div>
</template>

<script>
    export default {
        name: 'import-summary-content',
        props: ['tableData','import_status'],
        components: {
        },
        data() {
					return {
							
					}
        },
				methods: {
        },
    }
</script>